export default __webpack_public_path__ + "static/media/Filter.7f4de0c4.svg";